// What the Bildirimler screen says when bildirimler are deleted (views/Notifications.tsx).
import { fmt } from './format';

/** What was deleted: one from its row, the read ones ("Okunanları sil") or all of them ("Tümünü sil"). */
export type Removal = 'one' | 'read' | 'all';

/** "Tümünü sil" asks first: deleted bildirimler cannot be brought back. */
export function clearAllQuestion(total: number): string {
  return `${fmt.n(total)} bildirim silinsin mi? Geri alınamaz.`;
}

/** The toast after a deletion; none deleted means another tab or device was faster. */
export function removedText(deleted: number, what: Removal): string {
  if (what === 'one') return deleted > 0 ? 'Bildirim silindi' : 'Bildirim zaten silinmiş';
  if (deleted === 0) return what === 'read' ? 'Silinecek okunmuş bildirim yok' : 'Silinecek bildirim yok';
  return `${fmt.n(deleted)} ${what === 'read' ? 'okunmuş ' : ''}bildirim silindi`;
}
